<template>
  <l-layout :layout="['xs12']">
    <l-data-table
      :headers="header"
      :get-data-func="getServiceList"
      clickable
      title-text="硬件服务列表"
      @click:row="getDetails($event.item)"
      ref="serviceList">
      <template slot="row-action" slot-scope="{item}">
        <td @click.stop class="px-0 mx-0 text-xs-center">
          <v-tooltip left>
            <v-btn @click="deleteServiceConfirm(item)" slot="activator" icon>
              <v-icon small>$vuetify.icons.delete</v-icon>
            </v-btn>
            <span>删除服务</span>
          </v-tooltip>
        </td>
      </template>
    </l-data-table>
    <l-fixed-btn
      @click="addDevice"
      icon="$vuetify.icons.add"
    ></l-fixed-btn>
  </l-layout>
</template>

<script>
  import {time} from '../../../ladmin/utils/time'
  import LDataTable from "../../../ladmin/components/LDataTable/LDataTable";
  export default {
    name: "iotServiceList",
    components: {LDataTable},
    data(){
      return {
        header:[
          {text:'设备名称',value:'name',sortable:false,align:'left'},
          {text:"创建时间",value:'creationTime',sortable:true,align:'left',f:(v)=>time.stringify(v)},
          {text:'创建者',value:'creator',sortable:false,align:'left'},
          {text:'',value:'',sortable:false,align:'left'}
        ]
      }
    },
    methods:{
      async getServiceList({pagination, sortStack, filterItems, search}){
        let {items,amount} = await this.$store.dispatch('iot/getServiceList',{pagination,search:{key:'name',value:search}});
        console.log(items)
        return {items:items,amount:amount}
      },
      addDevice(){
        this.$router.push({name:'newIotService'})
      },
      async deleteServiceConfirm (item) {
        let {res, close} = await this.$L.confirm({
          title: '确认删除该服务？',
          text: '服务名称:' + item.name
        })
        if (res) {
          try {
            await this.deleteService(item)
          }
          catch (e) {
            this.$L.alert('error', e.message)
          }
        }
        close()
      },
      async deleteService (item) {
        let ids = []
        ids.push(item.id)
        let params = {
          "ids":ids
        }
        let res = await this.$store.dispatch('iot/deleteService', params)
        if (res.data.status + '' === '200') {
          this.$L.alert('success', {message: '删除成功'})
          this.$refs.serviceList.refresh()
        }
        else {
          this.$L.alert('error', {message: '删除失败，原因：' + res.data.msg})
        }
      },
      getDetails(item){
        let selectionString = document.getSelection().toString()
        if (!selectionString) {
          this.$router.push({name:'iotServiceDetailBox',query:{id:item.id}})
        }
      }
    }
  }
</script>

<style scoped>

</style>
